import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CheckmarkGlyph = /*#__PURE__*/createElement("g", {
  id: "checkmark",
  style: {
    transform: 'translate(16%, 25%) scale(4.8)'
  },
  fill: "none"
}, /*#__PURE__*/createElement("path", {
  d: "M10.998 0L11.707 0.703125L3.85547 8.56055L0 4.70508L0.708984 3.99609L3.85547 7.14258L10.998 0Z"
}));
const Checkmark = createSvg({
  name: 'checkmark',
  path: CheckmarkGlyph
});

export default Checkmark;
export { CheckmarkGlyph };
